import Model from '@ember-data/model';
import attr from 'ember-data/attr';

export default class EventDataModel extends Model {
  @attr('string') type!: string;
  @attr('string') name!: string;
  @attr('number') timestamp!: number;
  @attr('number') processedAt!: number;
  @attr('string') internalId!: string;
  @attr() attrs!: Record<string, unknown>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    eventData: EventDataModel;
  }
}
